"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const Previews_style_1 = require("../Previews.style");
const ChartHeader = ({ chartType, isContentLoading }) => {
    const { search } = (0, react_router_1.useLocation)();
    const history = (0, react_router_1.useHistory)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-inline justify-space-between align-center m-m", children: [(0, jsx_runtime_1.jsx)(Previews_style_1.ChartTitle, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `admin.analytics.${chartType}.title` }) }), (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "align-self-end", type: "secondary", size: "middle", disabled: isContentLoading, onClick: () => history.pushLocalized(`/admin/reporty/${chartType.replace(new RegExp('_', 'ig'), '-')}${search}`), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.analytics.view_report" }) })] }));
};
exports.ChartHeader = ChartHeader;
